import { createAsyncThunk } from "@reduxjs/toolkit";
import useAxios from "../../utils/useAxios";
import { URL_REQUIREMENT_TEMPLATES } from "../../config/connString";

const deleteRequirementTemplate = createAsyncThunk(
  "lab-requirements/delete-requirement-template",
  async (data) => {
    try {
      const api = useAxios();
      const response = await api.delete(
        URL_REQUIREMENT_TEMPLATES + "/" + data?.id
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export { deleteRequirementTemplate };
